import { render, staticRenderFns } from "./BankFinancing-requirements-from-developer.vue?vue&type=template&id=37b8be97&"
import script from "./BankFinancing-requirements-from-developer.vue?vue&type=script&lang=js&"
export * from "./BankFinancing-requirements-from-developer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports